import "./styles.scss";

import React, { useEffect, useState } from "react";

import { API_URL } from "../../utils/constants";
import AlertMessage from "../lessons/trial/AlertMessage";
import { AppLoader } from "../../components/AppLoader";
import Communicate from "./Communicate";
import LanguageSettings from "./LanguageSettings";
import Layout from "../layout/Portal";
import Paymenthistory from "./Paymenthistory";
import UserProfile from "./UserProfile";
import { WalletSettings } from "./walletSettings";
import { toast } from "sonner";
import { useProfile } from "../../context/ProfileContext";
import { useTrialLesson } from "../../context/TrailLessonContext";
import { userProfile } from "./types";

export const Profile = () => {
  const { isTrialLessonCreated } = useTrialLesson();
  const { getUserInfo } = useProfile();
  const getRole = () => {
    const merchantRole = localStorage.getItem("Role");
    if (merchantRole !== null) {
      return merchantRole;
    } else return null;
  };
  const [values, updateValues] = useState<userProfile>({
    aboutYou: "",
    aboutYouAsTeacher: "",
    firstName: "",
    lastName: "",
    otherNames: "",
    email: "",
    youtubeUrl: "",
    interests: [],
    languagesSpoken: [
      {
        language: "",
        proficiency: "",
      },
    ],
    workExperiences: [
      {
        organization: "",
        jobRole: "",
        startDate: "",
        endDate: "",
      },
    ],
    educationalQualifications: [
      {
        level: "",
        endDate: "",
        startDate: "",
        institution: "",
        fieldOfStudy: "",
      },
    ],
    dpUrl: "",
    otherCertifications: [],
  });

  const [value, setValue] = useState({
    data: [],
    error: "",
    loading: false,
    submitError: "",
  });

  const [state, updateState] = useState({
    data: "",
    error: "",
    loading: false,
  });

  const [picked, setPicked] = useState("profile");

  const validate = () => {
    // Check required fields
    // if (!values.firstName) return setSubmitError("First Name is required.");
    // if (!values.lastName) return setSubmitError("Last Name is required.");
    // if (!values.email) return setSubmitError("Email Address is required.");
    if (!values.aboutYou) return setSubmitError("Please enter About Me.");
    if (!values.aboutYouAsTeacher)
      return setSubmitError("Please enter About Me As A Teacher.");

    // // Email validation
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // if (!emailRegex.test(values.email)) {
    //   return setSubmitError("Please enter a valid email address.");
    // }

    // // URL validation for YouTube URL
    // const urlRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/;
    // if (values.youtubeUrl && !urlRegex.test(values.youtubeUrl)) {
    //   return setSubmitError("Please enter a valid YouTube URL.");
    // }

    return true; // All validations passed
  };

  const setSubmitError = (message: string) => {
    setValue((prev) => ({ ...prev, submitError: message }));
    return false;
  };

  const handleSubmit = async (e: any, name: string) => {
    e.preventDefault();

    let changedData = { [name]: values[name as keyof userProfile] };

    if (changedData) {
      if (validate()) {
        const token = localStorage.getItem("token");
        const id = localStorage.getItem("id");
        const url = `${API_URL}/teachers/${id}`;

        setValue({ ...value, loading: true, error: "", submitError: "" });
        toast.info("updating Profile", {
          richColors: true,
          duration: 3000,
        });
        try {
          const response = await fetch(url, {
            method: "PATCH",
            headers: {
              authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(changedData),
          });

          const result = await response.json();

          if (response?.ok) {
            toast.success(`${getRole()} updated successfully`, {
              richColors: true,
              duration: 3000,
            });
            setValue({
              ...value,
              data: result.result,
              loading: false,
              submitError: "",
            });
          } else {
            setValue({
              ...value,
              loading: false,
              submitError: result.message ?? "Something went wrong",
            });
            throw new Error(`HTTP error!: ${response.status} please try again`);
          }
        } catch (error: any) {
          toast.error(error.message || "Some went wrong. try again", {
            richColors: true,
            duration: 3000,
          });

          setValue({
            ...value,
            loading: false,
            submitError: error.message ?? "Something went wrong",
          });
        }
      }
    } else {
      toast.error("an error occured", {
        richColors: true,
      });
    }
  };

  const fetchDetails = async () => {
    const token = await localStorage.getItem("token");
    const id = await localStorage.getItem("id");
    const role = localStorage.getItem("Role");
    let url;
    if (role === "teacher") {
      url = `${API_URL}/teachers/${id}`;
    } else {
      url = `${API_URL}/merchants/partners/details`;
    }

    updateState({ ...state, loading: true, error: "" });

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      // console.log(response);
      if (!result.error) {
        updateState({
          ...state,
          data: result.result,
          loading: false,
          error: "",
        });

        getUserInfo(result?.result);
        if (!response?.ok) {
          throw new Error(`Something went wrong:${response?.status}  Reload`);
        }
      } else {
        updateState({
          ...state,
          loading: false,
          error: result.message ?? "Something went wrong",
        });
      }
    } catch (err: any) {
      updateState({
        ...state,
        loading: false,
        error: err.message ?? "Something went wrong",
      });
    }
  };

  const _resetHandler = () => {
    updateValues({ ...values, aboutYou: "", aboutYouAsTeacher: "" });
  };

  const [preview, setPreview] = useState<string | null>(null);

  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/png"];
    const maxSize = 5 * 1024 * 1024;
    if (!validTypes.includes(file.type)) {
      toast.warning("Invalid file type. Only JPEG and PNG are allowed.", {
        richColors: true,
      });
      return;
    }
    if (file.size > maxSize) {
      toast.warning("File size exceeds the maximum limit of 5MB.", {
        richColors: true,
      });
      return;
    }

    const previewUrl = URL.createObjectURL(file);
    setPreview(previewUrl);

    const token = await localStorage.getItem("token");

    const formData = new FormData();
    formData.append("file", file);

    try {
      toast.info("Uploading", {
        richColors: true,
        duration: 3000,
      });

      // get current user
      const userType = await localStorage.getItem("Role");

      const merchantUrl = "teachers/profile-picture";
      const partnerUrl = "merchants/partners/profile-picture";

      const url = userType === "partner" ? partnerUrl : merchantUrl;
      const response = await fetch(`${API_URL}/${url}`, {
        method: "PATCH",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorDetails = await response.text();
        throw new Error(
          `Image upload failed: ${response.statusText}. Details: ${errorDetails}`,
        );
      }

      const data = await response.json();
      toast.success("Uploaded successfully", {
        richColors: true,
        duration: 2000,
      });
    } catch (error: any) {
      toast.error("Apologies, there was error uploading profile image.", {
        richColors: true,
        duration: 3000,
      });
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  return (
    <Layout color="transparent">
      <div className="" style={{ marginBottom: "2rem" }}>
        {!isTrialLessonCreated && <AlertMessage title="Action Required" />}
      </div>
      <div className="profileMainContainer">
        <p className="topSubTitleTop">Pofile</p>
        <p className="topTitle"> Manage your profile & Profile Settings</p>

        <div className="profileLeftContainer">
          <div
            onClick={() => setPicked("profile")}
            className={picked === "profile" ? "rightHeaderP" : "rightHeaderPU"}
          >
            <p className="topSubTitle">Profile</p>
            <br />
            {/* <p className="topTitle"> Manage your profile & Profile Settings</p> */}
          </div>
          <div
            onClick={() => setPicked("wallet")}
            className={picked === "wallet" ? "rightHeader" : "rightHeaderU"}
            data-test="wallet"
          >
            <p className="topSubTitle">Wallet</p>
            <br />
          </div>
          <div
            onClick={() => setPicked("history")}
            className={picked === "history" ? "rightHeader" : "rightHeaderU"}
            data-test="history"
          >
            <p className="topSubTitle">Payment</p>
            <br />
          </div>
          <div
            onClick={() => setPicked("communicate")}
            className={
              picked === "communicate" ? "rightHeader" : "rightHeaderU"
            }
            data-test="communicate"
          >
            <p className="topSubTitle">
              <span>Communication</span>
              <span className="mobHid"> Tools</span>
            </p>
            <br />
          </div>
          <div
            onClick={() => setPicked("language")}
            className={picked === "language" ? "rightHeader" : "rightHeaderU"}
            data-test="language"
          >
            <p className="topSubTitle">
              <span>Language</span>
              <span className="mobHid"> Settings</span>
            </p>
            <br />
          </div>
          {/* <div
            onClick={() => setPicked("more")}
            className={picked === "more" ? "rightHeader" : "rightHeaderU"}
          >
            <p className="topSubTitle">More</p>
            <br />
          </div> */}
        </div>
        {state.loading ? (
          <div className="loaderContainer">
            <AppLoader />
          </div>
        ) : picked === "profile" ? (
          <div className="profileRightContainer">
            <UserProfile
              profileData={values}
              setProfileData={updateValues}
              handleImage={handleImageChange}
              preview={preview}
              editables={handleSubmit}
            />
          </div>
        ) : picked === "wallet" ? (
          <WalletSettings />
        ) : picked === "history" ? (
          <Paymenthistory />
        ) : picked === "communicate" ? (
          <Communicate />
        ) : (
          picked === "language" && <LanguageSettings />
        )}
      </div>
    </Layout>
  );
};
